import { createAction, props } from "@ngrx/store";

export const fetchChannel = createAction(
  "[Channel] Fetch Channels",
  props<{ page, filterOptions }>()
);

export const fetchChannelSuccess = createAction(
  "[Channel] Fetch Channels Success",
  props<{ channel }>()
);

export const fetchChannelFailure = createAction(
  "[Channel] Fetch Channels Faild",
  props<{ error }>()
);

export const getChannel = createAction(
  "[Channel] Get Channel",
  props<{ id }>()
);

export const getChannelSuccess = createAction(
  "[Channel] Get Channel Success",
  props<{ channel }>()
);

export const getChannelFailure = createAction(
  "[Channel] Get Channel Failure",
  props<{ error }>()
);

export const addChannel = createAction(
  "[Channel] Add Channel",
  props<{ channel, filterOptions?: any }>()
);

export const addChannelSuccess = createAction(
  "[Channel] Add Channel Success",
  props<{ channel }>()
);

export const addChannelFailure = createAction(
  "[Channel] Add Channel Failure",
  props<{ error }>()
);

export const updateChannel = createAction(
  "[Channel] Update Channel",
  props<{ channel, filterOptions?: any }>()
);

export const updateChannelSuccess = createAction(
  "[Channel] Update Channel Success",
  props<{ channel }>()
);

export const updateChannelFailure = createAction(
  "[Channel] Update Channel Failure",
  props<{ error }>()
);

export const deleteChannel = createAction(
  "[Channel] Delete Channel",
  props<{ id, filterOptions?: any }>()
);

export const deleteChannelSuccess = createAction(
  "[Channel] Delete Channel Success",
  props<{ id }>()
);

export const deleteChannelFailure = createAction(
  "[Channel] Delete Channel Failure",
  props<{ error }>()
);
